module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAACCAYAAACnpNlpAAAAcklEQVQ4T+1RSQ7AIAjE/39ZhoYBomJ67akmBjOLbAPGIzARRmQ0ERAPrL8VjgevyRfmUelzLviI6xY3G65A6NTk5kymrj+CB7Xu2fW7rvKSpzZzbLnLu2putR/9ZG85m+qV3pd5xfzuGY9/Aefyvl7AA3WWIiOCdiL+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/titleft.png
// module id = 2LGJ
// module chunks = 2